import QRCode from "qrcode";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const isGateOnlyUser = (user) => {
  if (!user || user.role === "admin") return false;
  const perms = user.permissions || [];
  return perms.length > 0 && perms.every((p) => p.startsWith("gate."));
};

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

// Opens a small printable slip (80mm-friendly) with the scannable QR token.
export async function printGatePass(pass, dealerName = "") {
  const w = window.open("", "_blank", "width=420,height=640");
  if (!w) return;
  const qr = await QRCode.toDataURL(pass.token, { width: 260, margin: 1 });
  const isRide = pass.kind === "test_ride";
  const rows = isRide
    ? [["Job Card", pass.job_card_number], ["Vehicle", pass.vehicle_reg_no], ["Technician", pass.technician], ["Max time out", `${pass.max_minutes} min`]]
    : [["Invoice", pass.invoice_number], ["Type", pass.invoice_type === "counter_sale" ? "Counter Sale" : "Job Card"], ["Job Card", pass.job_card_number || "—"], ["Vehicle", pass.vehicle_reg_no || "—"], ["Customer", pass.customer_name]];
  w.document.write(`<!doctype html><html><head><title>${esc(pass.pass_no)}</title><style>
    body{font-family:Arial,Helvetica,sans-serif;margin:0;padding:16px;color:#111;width:300px}
    h1{font-size:13px;margin:0 0 2px;text-transform:uppercase;letter-spacing:.08em}
    .kind{display:inline-block;margin:6px 0 10px;padding:4px 8px;font-size:12px;font-weight:700;letter-spacing:.1em;color:#fff;background:${isRide ? "#b45309" : "#047857"}}
    .no{font-family:monospace;font-size:15px;font-weight:700}
    img{display:block;margin:10px auto;width:220px;height:220px}
    table{width:100%;border-collapse:collapse;font-size:12px}td{padding:3px 0;border-bottom:1px dashed #ccc}td:first-child{color:#555;width:42%}
    .foot{margin-top:10px;font-size:10px;color:#555;text-align:center}
    @media print{body{padding:4px}}
  </style></head><body>
    <h1>${esc(dealerName || "Service Gate Pass")}</h1>
    <div class="kind">${isRide ? "TEST RIDE TOKEN" : "CUSTOMER GATE PASS"}</div>
    <div class="no">${esc(pass.pass_no)}</div>
    <img src="${qr}" alt="QR"/>
    <table>${rows.map(([k, v]) => `<tr><td>${esc(k)}</td><td><b>${esc(v || "—")}</b></td></tr>`).join("")}
      <tr><td>Issued</td><td>${esc(fmtTime(pass.issued_at))}<br/>by ${esc(pass.issued_by_name)}</td></tr></table>
    <div class="foot">${isRide ? "Scan at gate on EXIT and again on RETURN." : "Valid for one exit. Show at the gate."}</div>
    <script>setTimeout(function(){window.print()},300)</script>
  </body></html>`);
  w.document.close();
}

export { fmtTime };
